import { useState } from 'react';
import { BrandFilter } from '@apps/components/BrandFilter';
import { CarLaunchNews } from '@apps/components/CarLaunch/CarLaunchNews';
import { SectionTitle } from '@apps/components/SectionTitle';
import TopBrandItem from '@apps/components/TopBrandItem';
import TopModelItem from '@apps/components/TopModelItem';
import AdsContainer from '@apps/containers/AdsContainer';
import RankingList from '@apps/containers/RankingList';
import RecommendCarList from '@apps/containers/RecommendCarList';
import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import createBasePath from '@stack/helpers/lib/createBasePath';
import { useGetResponsive } from '@stack/helpers/lib/responsive';
import { TitleDivider } from '@stack/ui';

import { StyledTab, StyledTabs } from './styledTab';
/**
 * ===========================
 * MAIN
 * ===========================
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const CarRankingScreen = ({
  location_city,
  location_state,
  data,
  popularBrand,
  webView,
}: {
  location_city: [];
  location_state: [];
  data?: any;
  webView?: boolean;
  popularBrand: any;
}) => {
  const [tabState, setTabState] = useState<number>(0);
  // ============ HOOKS
  const { isWeb } = useGetResponsive();
  const {
    brand_search_ranking,
    model_search_ranking,
    brand_sold_ranking,
    model_sold_ranking,
  } = data;

  // ============ VARIABLES
  const { basePath } = createBasePath({
    webView,
    type: 'cars',
  });
  const desktopPopularBrands = popularBrand?.slice(0, 16) ?? [];

  // ============ EVENTS
  const onHandleChange = (e: React.SyntheticEvent, newValue: number) => {
    setTabState(newValue);
  };

  // ============ VARIABLES
  const thisYear = new Date().getFullYear();

  // ============ VIEWS
  const renderRankingType = () => {
    if (tabState === 0) {
      return (
        <>
          <SectionTitle
            title={`Top Model Sales (${thisYear})`}
            // subItem={
            //   <Stack
            //     direction="row"
            //     style={{ gap: '8px', alignItems: 'center' }}
            //   >
            //     <InfoIcon fontSize={'small'} style={{ fill: '#737CBC' }} />
            //     <Typography
            //       style={{ fontSize: 14, fontWeight: 500 }}
            //     >{`Updated on ${MonthlySales.update_at}`}</Typography>
            //   </Stack>
            // }
          >
            <RankingList
              data={model_sold_ranking}
              renderItem={(item) => (
                <TopModelItem
                  {...item}
                  type={'Sold'}
                  location_city={location_city}
                  location_state={location_state}
                  webView={webView}
                />
              )}
            />
          </SectionTitle>
          <SectionTitle
            title={`Top Brand Sales (${thisYear})`}
            // subItem={
            //   <Stack
            //     direction="row"
            //     style={{ gap: '8px', alignItems: 'center' }}
            //   >
            //     <InfoIcon fontSize={'small'} style={{ fill: '#737CBC' }} />
            //     <Typography
            //       style={{ fontSize: 14, fontWeight: 500 }}
            //     >{`Updated on ${MonthlySales.update_at}`}</Typography>
            //   </Stack>
            // }
          >
            <RankingList
              data={brand_sold_ranking}
              renderItem={(item) => (
                <TopBrandItem
                  {...item}
                  type={'Sold'}
                  basePath={basePath}
                  webView={webView}
                />
              )}
            />
          </SectionTitle>
        </>
      );
    }
    return (
      <>
        <SectionTitle
          title="Model Monthly Search"
          // subItem={
          //   <Stack
          //     direction="row"
          //     style={{ gap: '8px', alignItems: 'center' }}
          //   >
          //     <InfoIcon fontSize={'small'} style={{ fill: '#737CBC' }} />
          //     <Typography
          //       style={{ fontSize: 14, fontWeight: 500 }}
          //     >{`Updated on ${MonthlySales.update_at}`}</Typography>
          //   </Stack>
          // }
        >
          <RankingList
            data={model_search_ranking}
            renderItem={(item) => (
              <TopModelItem
                {...item}
                type={'Search'}
                location_city={location_city}
                location_state={location_state}
                webView={webView}
              />
            )}
          />
        </SectionTitle>
        <SectionTitle
          title="Brand Monthly Search"
          // subItem={
          //   <Stack
          //     direction="row"
          //     style={{ gap: '8px', alignItems: 'center' }}
          //   >
          //     <InfoIcon fontSize={'small'} style={{ fill: '#737CBC' }} />
          //     <Typography
          //       style={{ fontSize: 14, fontWeight: 500 }}
          //     >{`Updated on ${MonthlySales.update_at}`}</Typography>
          //   </Stack>
          // }
        >
          <RankingList
            data={brand_search_ranking}
            renderItem={(item) => (
              <TopBrandItem
                {...item}
                type={'Search'}
                basePath={basePath}
                webView={webView}
              />
            )}
          />
        </SectionTitle>
      </>
    );
  };

  const renderlist = () => {
    return (
      <TitleDivider
        titleVariant="h1"
        title={webView ? '' : 'Ranking'}
        webView={webView}
      >
        <Stack sx={{ gap: { xs: '30px', md: '50px' } }}>
          <Box
            sx={{
              zIndex: 1,
              background: 'white',
              position: 'sticky',
              top: webView ? 0 : '50px',
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              borderBottom: '1px solid #EDECED',
            }}
          >
            <StyledTabs value={tabState} onChange={onHandleChange}>
              <StyledTab label={`Sales`} />
              <StyledTab label={`Top Search`} />
            </StyledTabs>
          </Box>
          {renderRankingType()}
          <AdsContainer
            style={{
              display: 'block',
              width: '100%',
            }}
            localPlacement={'xl_listing'}
          />
        </Stack>
      </TitleDivider>
    );
  };
  return (
    <Stack sx={{ gap: 1, overscrollBehavior: 'none', mt: webView ? -4.5 : 0 }}>
      <Stack
        style={{
          flexDirection: isWeb ? 'row' : 'column',
          gap: isWeb ? 30 : 0,
          paddingTop: webView ? 0 : '1rem',
        }}
        divider={
          isWeb ? <Divider orientation="vertical" flexItem /> : undefined
        }
      >
        <Stack
          sx={{
            minWidth: { xs: '100%', md: '70%' },
            maxWidth: { xs: '100%', md: '70%' },
          }}
        >
          {renderlist()}
        </Stack>

        {!webView && <CarLaunchNews webView={webView} />}
      </Stack>

      <BrandFilter
        title={isWeb ? 'Popular Brands in Malaysia' : undefined}
        brands={desktopPopularBrands}
        webView={webView}
        showInnerTitle={!isWeb}
        backgroundColor={isWeb ? '#fff' : undefined}
        mobilePadding={isWeb ? '25px' : '15px 10px'}
      />

      <RecommendCarList webView={webView} />
    </Stack>
  );
};

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default CarRankingScreen;
